// BREAKPOINS
export const breakpoints = {
  xs: 356,
  sm: 576,
  md: 768,
  lg: 1200,
  xl: 1400,
};
